import ButtonComponent from '@/components/ButtonComponent';
import Overlay from '@/components/Overlay';
import styled from 'styled-components';
import theme from '@/styles/theme';

interface MedicineDeleteModalProps {
  medicineName: string;
  onCloseModal: () => void;
  onSubmit: () => void;
}
const MedicineDeleteModal = ({
  medicineName,
  onCloseModal,
  onSubmit
}: MedicineDeleteModalProps) => {
  return (
    <Overlay index={2}>
      <ModalWrapper>
        <ModalTop>
          <Title>
            <span>{medicineName}</span>을{'\n'}삭제하시겠습니까?
          </Title>
          <Description>삭제시, 복구가 어렵습니다.</Description>
        </ModalTop>
        <ModalButtonWrapper>
          <ButtonComponent
            borderColor={theme.DF_COLOR.WHITE}
            bgColor={theme.DF_COLOR.WHITE}
            textColor={theme.DF_COLOR.BLACK}
            text={'취소'}
            padding={'1rem'}
            onClick={onCloseModal}
          />
          <ButtonComponent
            borderColor={theme.DF_COLOR.WHITE}
            bgColor={theme.DF_COLOR.WHITE}
            textColor={theme.DF_COLOR.BLACK}
            text={'삭제'}
            padding={'1rem'}
            onClick={onSubmit}
          />
        </ModalButtonWrapper>
      </ModalWrapper>
    </Overlay>
  );
};

export default MedicineDeleteModal;

const ModalWrapper = styled.div`
  width: 420px;

  ${({ theme }) => `
    background: ${theme.DF_COLOR.WHITE};
    border:1px solid ${theme.DF_COLOR.GRAY100};
    border-radius: 4px;
  `};
`;

const ModalTop = styled.div`
  padding: 40px;
  text-align: center;
`;

const Title = styled.div`
  white-space: break-spaces;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI20SB};
    color: ${theme.DF_COLOR.GRAY800};

    span {
      color: ${theme.DF_COLOR.PRIMARY600};
    }
  `};
`;

const Description = styled.div`
  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI14M};
    color: ${theme.DF_COLOR.GRAY600};
  `};
`;

const ModalButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;
  ${({ theme }) => `
    border-top: 1px solid ${theme.DF_COLOR.GRAY100};
  `};

  > * {
    flex: 1;
    &:not(:last-child) {
      border-start-end-radius: 0;
      border-end-end-radius: 0;
      ${({ theme }) => `
        border-right: 1px solid ${theme.DF_COLOR.GRAY100};
      `};
    }
  }
`;
